import { SectionWidth } from "@/types/section";

export const widthMap: Record<SectionWidth, string> = {
    full: "6",
    half: "3",
    "one-third": "2",
    "two-thirds": "4",
};